import { RichTextInput } from 'ra-input-rich-text';
import { DateInput, DateTimeInput, Edit, FormDataConsumer, SelectInput, SimpleForm, TextInput, required } from 'react-admin';
import {FileInput} from '../fileinputs/eventFileUpload';


export function PaintingEdit(props) {
    return (
        <Edit  {...props}>
            <SimpleForm>
                <TextInput source="title" validate={required()} />
                <RichTextInput source="description" />
                <FileInput source="images" edit add />
            </SimpleForm>
        </Edit>
    )
}




